import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from './config.service';
import {WriteOff} from '../model/WriteOff';

@Injectable()
export class WriteOffService {
    constructor(private httpClient: HttpClient, private configService: ConfigService) {
    }

    public async getWriteOffByLoanId(loanId: string): Promise<WriteOff> {
        const url = `${this.configService.baseUrl()}write-off?loanId=${loanId}`;
        return await this.httpClient.get<WriteOff>(url).toPromise();
    }
}